import { ParameterCategory } from "components/CC/UI/ParameterPicker/ParameterPicker";
import { createContext, Dispatch, useContext } from "react";

import { FilterContext } from "./types/filterEditor";
import { FilterEditorAction } from "./utils/filterEditorReducer";
import { FilterEditorError } from "./utils/filterEditorSchema";

export interface FilterEditorContextValue {
    context: FilterContext;
    dispatch: Dispatch<FilterEditorAction>;
    /** Picker category of the "Lead data" rule, `null` while no form structure with fields is available */
    fieldsCategory: ParameterCategory | null;
    showErrors: boolean;
    errorsByNode: Map<string, FilterEditorError[]>;
}

const FilterEditorContext = createContext<FilterEditorContextValue | null>(null);

export const FilterEditorContextProvider = FilterEditorContext.Provider;

export const useFilterEditorContext = (): FilterEditorContextValue => {
    const value = useContext(FilterEditorContext);
    if (!value) {
        throw new Error("useFilterEditorContext must be used inside <FilterEditor>");
    }
    return value;
};
